import { render, staticRenderFns } from "./UpdateApp.vue?vue&type=template&id=6a07fcc1"
import script from "./UpdateApp.vue?vue&type=script&lang=js"
export * from "./UpdateApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports